<template>
  <svg width="50" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="callPhoneSvg-container2">
      <path d="M200 0H0V3.5H200V0Z" fill="white"/>
      <path d="M200 96.5H0V100H200V96.5Z" fill="white"/>
      <path d="M33.5 20V32L18.5 49.9L33.5 67.8V80H173.5V20H33.5Z" fill="#ED4625"/>
      <path d="M62.4 51.8C60.8 52.4 59.1 53.2 57.1 54V65.2C57.1 67.4 56 68.3 53.8 68.3H49.9L49.3 65.7C51 65.9 52.3 65.9 52.9 65.9C53.5 66.1 54.3 65.6 54.3 64.8C54.3 64.6 54.3 64.5 54.3 64.5V55C51.5 55.8 49.6 56.4 48.6 56.7L48 54.2C50.3 53.7 52.5 53.1 54.5 52.5V43.8H48.6V41.2H54.5V34.5H57.3V41.2H62.1V43.8H57.3V51.4C59 50.8 60.7 50 62.6 49.1V51.7H62.4V51.8V51.8ZM63 37.3H81.6V40H75.7V64.9C76 66.6 74.8 68.2 73.2 68.3C72.9 68.3 72.6 68.3 72.3 68.3H66.2L65.6 65.7C68.2 65.9 70.3 65.9 71.3 65.9C72.3 65.9 72.9 65.3 72.9 64.2V40H63V37.3Z" fill="white"/>
      <path d="M100.4 58.1H91.2V61.2H88.6V39.5H100.4V34.5H103.2V39.6H115.3V58.2H103.2V62.7C103.2 64.6 104 65.5 105.7 65.5H114.2C115 65.5 115.6 65.3 116.2 64.9C116.8 63.5 117 61.9 117 60.4L119.6 61.2C119.3 64.5 119 66.3 118.4 66.9C117.3 67.7 116.1 68 114.8 67.8H105.2C102.1 67.8 100.7 66.2 100.7 62.8L100.4 58.1ZM100.4 42.1H91.2V47.5H100.4V42.1ZM91.3 50.1V55.7H100.5V50.1H91.3ZM112.5 47.6V42.2H103V47.6H112.5ZM103.1 55.7H112.6V50.1H103.1V55.7Z" fill="white"/>
      <path d="M122.6 45.7H130.7V62.3C132.1 61.2 133.5 60 134.9 58.6L135.7 61.4C133.5 63.6 131 65.4 128.4 67.1L127.3 64.8C127.8 64.5 128.1 63.9 128.1 63.2V48.4H122.7V45.7H122.6V45.7ZM127 34.8C129.3 36.5 131.5 38.4 133.4 40.5L131.5 42.4C129.6 40.2 127.5 38.4 125.1 36.7L127 34.8ZM134.4 45.2H144.7V39.3C141.9 39.6 139 39.8 136 39.8L135.2 37.3C141.7 37.5 148.2 36.7 154.5 34.7L155.7 37C153.1 37.9 150.3 38.6 147.5 39V45.2H157.1V47.8H147.5V53.9H154.5V68.5H151.9V66.6H140.4V68.5H137.8V53.9H144.8V47.8H134.5L134.4 45.2ZM140.3 64H151.8V56.2H140.3V64Z" fill="white"/>
    </g>
  </svg>
</template>
<script>
export default {
  mounted () {
    this.animation()
  },
  methods: {
    animation () {
      setTimeout(() => {
        var anime = this.$anime
        var container = document.getElementById('callPhoneSvg-container2')
        var boxTimeLine = anime.timeline({
          targets: container,
          duration: 100,
          easing: 'linear',
          loop: true
        })
        boxTimeLine.add({
          rotate: 3
        }).add({
          rotate: -3
        }).add({
          rotate: 3
        }).add({
          rotate: -3
        }).add({
          rotate: 0
        }).add({}, '+=1500')
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/compos/callPhoneSvg2.vue